/* src/modules/create_tutor/Scene.js */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import AddTutorsSuccessCard from './cards/AddTutorsSuccessCard';
import CreateTutorCard from './cards/CreateTutorCard';
import CreateMultipleTutorsCard from './cards/CreateMultipleTutorsCard';

const CreateTutor = () => (
  <Grid container spacing={16}>
    <Grid item xs={12}>
      <Grid container spacing={16}>
        <Grid item xs={12}>
          <CreateTutorCard />
        </Grid>
        <Grid item xs={12}>
          <AddTutorsSuccessCard />
        </Grid>
      </Grid>
    </Grid>
    {/*
    <Grid item xs={12} md={6}>
      <CreateMultipleTutorsCard />
    </Grid>
    */}
  </Grid>
);

export default withStyles({})(CreateTutor);



// WEBPACK FOOTER //
// ./src/modules/create_tutor/Scene.js